export { default, default as NumberBadge } from './NumberBadge'
export { default as numberBadgeTheme } from './themes/NumberBadge.theme'
export * as NumberBadgeStyles from './styles/NumberBadge.style'

export type { NumberBadgeProps } from './NumberBadge.types'
export type { AppearanceKeys, NumberBadgeTheme } from './themes/NumberBadge.theme.types'
export type { StyledNumberBadgeProps } from './styles/NumberBadge.style.types'
